import VerificationRequestModal from "./VerificationRequestModal"

export default VerificationRequestModal
